import React, { useEffect, useMemo, useState } from "react";
import { ChevronDown, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n";

const Careers = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [langTick, setLangTick] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const tr = useMemo(() => {
    void langTick;

    return {
      back: i18n.t("careers.back"),
      title: i18n.t("careers.title"),
      intro: i18n.t("careers.intro"),
      apply: i18n.t("careers.apply"),
      jobs: [
        {
          title: i18n.t("careers.jobs.0.title"),
          description: i18n.t("careers.jobs.0.description"),
        },
        {
          title: i18n.t("careers.jobs.1.title"),
          description: i18n.t("careers.jobs.1.description"),
        },
        {
          title: i18n.t("careers.jobs.2.title"),
          description: i18n.t("careers.jobs.2.description"),
        },
        {
          title: i18n.t("careers.jobs.3.title"),
          description: i18n.t("careers.jobs.3.description"),
        },
      ],
    };
  }, [langTick]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-7xl mx-auto py-12 px-6 mb-20">
      <div
        className="flex items-center text-gray-600 cursor-pointer hover:text-gray-800 mb-6"
        onClick={() => window.history.back()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") window.history.back();
        }}
      >
        <ArrowLeft size={20} />
        <span className="ml-2">{tr.back}</span>
      </div>

      <h1 className="mt-20 text-6xl font-bold text-blue-700 mb-6">
        {tr.title}
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <div className="mb-6">
            <p className="text-gray-600 mb-6">{tr.intro}</p>

            <button
              className="bg-blue-600 text-white px-12 py-2 rounded-full mb-12 hover:bg-blue-700"
              onClick={() => navigate("/form")}
              type="button"
            >
              {tr.apply}
            </button>
          </div>
        </div>

        <div>
          {tr.jobs.map((job, index) => (
            <div key={index} className="border-b border-gray-300">
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex justify-between items-center p-4 text-left text-lg font-medium"
                type="button"
              >
                {job.title}
                <ChevronDown
                  size={20}
                  className={`transform transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openIndex === index && (
                <div className="p-4 text-gray-600">{job.description}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Careers;

